import moment from 'moment';
import { Component } from 'react';
import BlockUi from 'react-block-ui';
import {
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  FormGroup,
  Modal
} from 'react-bootstrap';
import { connect } from 'react-redux';
import 'sweetalert2/src/sweetalert2.scss';
import { addFlag } from '../../../redux/actions/app-actions';
import { fetchTagsByUser } from '../../../redux/actions/flag-actions';
import { RESERVED_TAGS } from '../../../constants/constants';
import { firebase } from '../../../firebase';
import withAuthorization from '../../../session/with_authorization';
import {
  isAITag,
  isRetrievalTag,
  validateTagInput
} from '../../../utils/tagValidatorUtils';
import { displayNotification } from '../../../utils/utils';

class ModalTag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blocking: false,
      addTag: false,
      valueTag: [],
      showAlert: false,
      message: null,
      error: false,
      flag: true // control tag inputs state
    };
  }

  handleClose = () => {
    this.setState({ addTag: false });
    this.props.onHide();
  };

  handleSave = () => {
    const [isValid, errorMessage] = validateTagInput(this?.newTag?.value);

    if (!isValid && errorMessage) {
      displayNotification(errorMessage);
      return;
    }

    const params = {
      trackPosition: parseInt(this.props.track, 10),
      url: this.props.playerDocument.episode.url,
      imgUrl: this.props.playerDocument.imgUrl,
      tag: !this.props.showSelect
        ? 'MyAudioFeedback'
        : this.newTag && this.newTag.value
        ? this.newTag.value
        : this.tag.value,
      podcastId: this.props.playerDocument.podcastId,
      dictation: this.dictation.value ? this.dictation.value : null,
      artistName: this.props.playerDocument.artistName,
      timestamp: moment().format('YYYY-MM-DD[T]HH:mm[Z]'),
      releaseDate: this.props.playerDocument.releaseDate,
      documentName: this.props.playerDocument.documentName,
      podcastName: this.props.playerDocument.podcastName
    };

    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props
          .dispatch(
            addFlag(
              token,
              params,
              () => {
                this.setState({
                  showAlert: true,
                  error: false,
                  message: 'Flag Added',
                  addTag: false
                });
                this.sendData(
                  this.state.showAlert,
                  this.state.error,
                  this.state.message
                );
              },
              () => {
                this.setState({
                  showAlert: true,
                  error: true,
                  message: 'Something went wrong',
                  addTag: false
                });
                this.sendData(
                  this.state.showAlert,
                  this.state.error,
                  this.state.message
                );
              }
            )
          )
          .then(() => {
            this.props.dispatch(fetchTagsByUser(token));
          });
      });
    }
    this.props.onHide();
  };

  sendData = (alert, error, mess) => {
    this.props.parentCallback(alert, error, mess);
  };

  handleChange = () => {
    this.setState({ flag: !this.state.flag });
  };

  createListWithTags = () => {
    const {
      MY_AUDIO_FEEDBACK,
      UNTAGGED,
      UPTAG,
      DOWNTAG,
      FLASH
    } = RESERVED_TAGS;
    let array = [];
    let temp = {};
    let isPresent = false;
    let tags = this.props.tags;
    temp.value = UNTAGGED;
    temp.text = UNTAGGED;
    array.push(temp);
    if (tags && tags.length > 0) {
      tags.forEach((p) => {
        if (p.tag === FLASH && !isPresent) {
          temp = {};
          isPresent = true;
          temp.value = p.tag;
          temp.text = p.tag;
          array.push(temp);
        } else if (
          p.tag !== FLASH &&
          p.tag !== MY_AUDIO_FEEDBACK &&
          p.tag !== UPTAG &&
          p.tag !== DOWNTAG &&
          !isAITag(p.tag) &&
          !isRetrievalTag(p.tag)
        ) {
          temp = {};
          temp.value = p.tag;
          temp.text = p.tag;
          array.push(temp);
        }
      });
    }

    return array;
  };

  render() {
    const tags = this.createListWithTags(this.props.tags);
    const enableSubmit =
      (this.tag && this.tag.value !== '-1') ||
      (this.newTag && this.newTag.value !== '') ||
      !this.props.showSelect;

    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          aria-labelledby="contained-modal-title"
          backdrop="static"
        >
          <Modal.Header closeButton>
            {this.props.showSelect ? (
              <Modal.Title id="contained-modal-title">
                Add tag to your flag
              </Modal.Title>
            ) : (
              <Modal.Title id="contained-modal-title">
                Add dictation to your flag
              </Modal.Title>
            )}
          </Modal.Header>
          <BlockUi tag="div" blocking={this.state.blocking}>
            <Modal.Body>
              {this.props.showSelect ? (
                <FormGroup controlId="tags">
                  <ControlLabel className="tagsLabel">Tag</ControlLabel>
                  <FormControl
                    componentClass="select"
                    className="selectTag"
                    inputRef={(el) => (this.tag = el)}
                    onChange={this.handleChange}
                  >
                    <option value="-1">Select a tag...</option>
                    {tags
                      ? tags.map((option, index) => {
                          return (
                            <option key={index} value={option.tag}>
                              {option.tag}
                            </option>
                          );
                        })
                      : ''}
                  </FormControl>
                  <Button
                    className={`${
                      this.state.addTag ? 'addTag buttonAdd' : 'addTag'
                    }`}
                    title="Add new tag"
                    onClick={() =>
                      this.setState({ addTag: !this.state.addTag })
                    }
                  >
                    +
                  </Button>
                  {this.state.addTag ? (
                    <FormControl
                      type="text"
                      style={{ width: '200px' }}
                      inputRef={(el) => (this.newTag = el)}
                      onChange={this.handleChange}
                    />
                  ) : null}
                </FormGroup>
              ) : (
                ''
              )}
              <FormGroup controlId="dictation">
                <ControlLabel>Dictation</ControlLabel>
                <FormControl
                  componentClass="textarea"
                  inputRef={(el) => (this.dictation = el)}
                  style={{ resize: 'none' }}
                  rows={3}
                />
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <ButtonToolbar className="pull-right">
                <Button
                  bsStyle="success"
                  onClick={this.handleSave}
                  disabled={!enableSubmit}
                >
                  Save
                </Button>
              </ButtonToolbar>
            </Modal.Footer>
          </BlockUi>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  userFlag: store.app.userFlag,
  tags: store.flag.tags
});

const authCondition = (authUser) =>
  !!authUser &&
  (authUser.userStatus === 'subscribed' || authUser.userStatus === 'free');

export default withAuthorization(authCondition)(
  connect(mapStateToProps)(ModalTag)
);
